import { type RouteObject } from 'react-router';
import { RoutesList } from '../../config/routes-list';
import MainLayout from '../../layouts/MainLayout';
import { lazyRouteNamed } from '../lazy-route';

export const teamRoutes: RouteObject[] = [
  {
    path: RoutesList.TEAM,
    element: <MainLayout />,
    children: [
      {
        index: true,
        ...lazyRouteNamed(() => import('../../pages/team/main-page'), 'TeamPage'),
      },
    ],
  },
];
